
import PageLayout from "components/layout/PageLayout"
import { useEditEmployeeMutation, useGetEmployeeQuery } from "./api/employmentApiSlice"
import { useGetCompanyRolesQuery } from "../companyRoles/api/companyRolesApiSlice"
import { useGetBusinessUnitsQuery } from "../businessUnit/api/businessUnitApiSlice"
import { useGetWorkerContractQuery, useSaveWorkerContractMutation } from "../../hr/workContract/api/workContractApiSlice"
import { useTranslation } from "react-i18next"
import { useLocation } from "react-router-dom"
import SuccessMessage from "components/commons/SuccessMessage"
import EmploymentForm from "./components/EmploymentForm"

const EditEmployment = () => {
  const [t] = useTranslation(["global"])
  const location = useLocation()
  const userGUID = location.state.userGUID

  const [editEmployee, { data: resUser, isLoading: loadingEdit, isSuccess: successEdit }] = useEditEmployeeMutation()
  const { data: userData, isFetching: loadingUser } = useGetEmployeeQuery(userGUID)
  const { data: roles, isFetching: loadingRoles } = useGetCompanyRolesQuery()
  const { data: units, isFetching: loadingUnits } = useGetBusinessUnitsQuery()
  const { data: contract, isFetching: loadingContract } = useGetWorkerContractQuery(userGUID)
  const [saveContract] = useSaveWorkerContractMutation()

  const initialData = userData ? {
    name: userData[0].user.name,
    surname: userData[0].user.surname,
    username: userData[0].user.username,
    email: userData[0].user.email,
    roleGuid: userData[0].role.guid,
    roleLabel: userData[0].roleLabel || "",
    siteGuid: userData[0].businessUnit?.guid || "",
    isEmployee: Boolean(contract),
    workContract: contract
  } : {}

  const handleSubmit = async (formData) => {
    console.log("FormData: "+ JSON.stringify(formData))
    const { name, surname, username, email, password, roleGuid, roleLabel, businessUnitGuid, isEmployee, workContract } = formData
    const payload = {
      userProfile: {
        guid: userData[0].user.guid,
        username,
        name: name,
        surname: surname,
        email
      },
      roleGuid, 
      businessUnitGuid,
      roleLabel,
      ...(password && { newPassword: password })
    }

    if (isEmployee) {
      await saveContract({
        userGuid: userData[0].user.guid,
        week: workContract.week,
        employmentDate: workContract.employmentDate,
        workerClassGuid: workContract.workerClass.guid

      }).unwrap()
    }

    await editEmployee(payload).unwrap()
  }

  const anyLoading = loadingUser || loadingRoles || loadingUnits || loadingContract || loadingEdit

  return (
    <PageLayout
      pageTitle={t("menu.edit_employment")}
      isLoadingPage={anyLoading}
      isLoadingContent={loadingEdit}
      isError={false}
      bodyContent={
        <>
          {successEdit && <SuccessMessage />}
          <EmploymentForm
            mode="edit"
            initialData={initialData}
            roles={roles || []}
            businessUnits={units || []}
            onSubmit={handleSubmit}
            isLoading={loadingEdit}
            t={t}
          />
        </>
      }
    />
  )
}

export default EditEmployment
